/* Do not change this file. */

/* Used in authentication */
export const ROLE = {
  ADMIN: "admin"
};
